query ListParameterGroups {
    parameterGroups {
        id
        name(language: "en") {
            language
            text
        }
        order
    }
}
